<template>
  <button
    v-tooltip.top="`Heading`"
    class="border rounded px-2 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="toggleHeading"
  >
    <Icon
      name="tabler:heading"
      class="h-[20px] w-[20px] "
    />
  </button>
  <Menu
    id="overlay_menu"
    ref="headingMenu"
    :model="headings"
    :popup="true"
  />
</template>

<script setup lang="ts">
const editor = defineModel('editor')

const headingMenu = ref()
const headings = ref([

  {
    label: 'Heading 1',
    command: () => {
      editor.value.chain().focus().toggleHeading({ level: 1 }).run()
    },
  },
  {
    label: 'Heading 2',
    command: () => {
      editor.value.chain().focus().toggleHeading({ level: 2 }).run()
    },
  },
  {
    label: 'Heading 3',
    command: () => {
      editor.value.chain().focus().toggleHeading({ level: 3 }).run()
    },
  },
  {
    label: 'Paragraph',
    command: () => {
      editor.value.chain().focus().setParagraph().run()
    },
  },

])
const toggleHeading = (event) => {
  headingMenu.value.toggle(event)
}
</script>

<style>
h1{
    font-size: 2em;
}
h2{
    font-size: 1.5em;
}
h3{
    font-size: 1.17em;
}
</style>
